import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDateNov = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("g", {
			id: `${__svgrId}-Date Icons`,
			children: /* @__PURE__ */ _jsx("g", {
				id: `${__svgrId}-Icon / Date / November`,
				children: /* @__PURE__ */ _jsxs("g", {
					id: `${__svgrId}-Icons`,
					children: [
						/* @__PURE__ */ _jsx("rect", {
							height: 24.9624,
							id: `${__svgrId}-Rectangle 61`,
							stroke: "white",
							strokeLinejoin: "round",
							strokeWidth: 2.5,
							style: { fill: "var(--sticker-pastel,#FFE29A)" },
							width: 22.4432,
							x: 4.6789,
							y: 3.9967
						}),
						/* @__PURE__ */ _jsx("rect", {
							height: 22.4624,
							id: `${__svgrId}-Rectangle 59`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: {
								fill: "var(--sticker-pastel,#FFE29A)",
								stroke: "var(--sticker-dark,#B87C1F)"
							},
							width: 19.9432,
							x: 5.9289,
							y: 5.2468
						}),
						/* @__PURE__ */ _jsx("rect", {
							fill: "white",
							height: 12.9712,
							id: `${__svgrId}-Rectangle 60`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#B87C1F)" },
							width: 19.9432,
							x: 5.9311,
							y: 14.7382
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M7.7947 12.8961 L7.7946 7.2961 L9.0587 7.2961 L11.4507 10.8242 L11.4507 7.2961 L12.7146 7.2961 L12.7146 12.8962 L11.4507 12.8962 L9.0586 9.3841 L9.0587 12.8962 L7.7947 12.8961 Z M16.1465 12.9921 C15.7625 12.9921 15.3945 12.9255 15.0426 12.7921 C14.6959 12.6588 14.3838 12.4668 14.1065 12.2161 C13.8345 11.9655 13.6185 11.6615 13.4585 11.3041 C13.3039 10.9468 13.2266 10.5441 13.2265 10.0962 C13.2265 9.6482 13.3039 9.2454 13.4586 8.8882 C13.6185 8.5308 13.8345 8.2268 14.1066 7.9761 C14.3839 7.7254 14.6958 7.5335 15.0426 7.4001 C15.3946 7.2668 15.7626 7.2001 16.1465 7.2001 C16.5305 7.2001 16.8985 7.2668 17.2505 7.4001 C17.6026 7.5335 17.9146 7.7255 18.1865 7.9761 C18.4639 8.2268 18.6825 8.5308 18.8425 8.8881 C19.0025 9.2454 19.0826 9.6481 19.0825 10.0961 C19.0826 10.5441 19.0025 10.9468 18.8426 11.3041 C18.6825 11.6615 18.4639 11.9655 18.1866 12.2161 C17.9145 12.4668 17.6026 12.6588 17.2506 12.7921 C16.8986 12.9255 16.5306 12.9921 16.1465 12.9921 Z M16.1465 11.8481 C16.4079 11.8482 16.6638 11.7841 16.9146 11.6561 C17.1652 11.5281 17.3706 11.3362 17.5305 11.0802 C17.6959 10.8189 17.7786 10.4908 17.7785 10.0961 C17.7785 9.6961 17.6959 9.3681 17.5305 9.1122 C17.3652 8.8508 17.1572 8.6589 16.9066 8.5361 C16.6559 8.4082 16.4025 8.3441 16.1465 8.3441 C15.8906 8.3442 15.6372 8.4082 15.3866 8.5361 C15.1412 8.6588 14.9359 8.8508 14.7705 9.1121 C14.6106 9.3681 14.5305 9.6961 14.5305 10.0961 C14.5306 10.4908 14.6105 10.8188 14.7705 11.0801 C14.9305 11.3362 15.1332 11.5282 15.3785 11.6562 C15.6292 11.7842 15.8852 11.8481 16.1465 11.8481 Z M20.8593 12.8961 L18.8513 7.2961 L20.1873 7.2961 L21.6513 11.6241 L23.1153 7.2961 L24.4433 7.2961 L22.4272 12.8962 L20.8593 12.8961 Z",
							id: `${__svgrId}-NOV`,
							style: { fill: "var(--sticker-dark,#B87C1F)" }
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 34`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 9.942,
							x2: 9.942,
							y1: 15.3986,
							y2: 27.0677
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 38`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 13.9199,
							x2: 13.9198,
							y1: 15.3984,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 36`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5944,
							x2: 25.153,
							y1: 19.1321,
							y2: 19.1321
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 37`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5949,
							x2: 25.1535,
							y1: 23.0835,
							y2: 23.0835
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 35`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 17.7503,
							x2: 17.7503,
							y1: 15.3984,
							y2: 27.0675
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 39`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 21.7954,
							x2: 21.7954,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M12.8152 4.3477 L12.8151 6.1461",
							id: `${__svgrId}-Line 40`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#B87C1F)" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M19.2456 4.3477 L19.2456 6.146",
							id: `${__svgrId}-Line 41`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#B87C1F)" }
						})
					]
				})
			})
		})
	});
};
export default SvgDateNov;
